import React, { createContext, useState, useContext, useEffect } from 'react';

const CompareContext = createContext();

export const useCompare = () => useContext(CompareContext);

export const CompareProvider = ({ children }) => {
    const [compareList, setCompareList] = useState(() => {
        try {
            const saved = localStorage.getItem('compareList');
            return saved ? JSON.parse(saved) : [];
        } catch (e) {
            console.error('Failed to parse compareList from localStorage', e);
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem('compareList', JSON.stringify(compareList));
    }, [compareList]);

    const addToCompare = (car) => {
        if (compareList.length >= 3) {
            return { success: false, message: 'Maximun 3 véhicules à comparer.' };
        }
        if (compareList.find(c => c.id === car.id)) {
            return { success: false, message: 'Ce véhicule est déjà dans le comparateur.' };
        }
        setCompareList([...compareList, car]);
        return { success: true, message: 'Véhicule ajouté au comparateur.' };
    };

    const removeFromCompare = (carId) => {
        setCompareList(compareList.filter(c => c.id !== carId));
    };

    const clearCompare = () => {
        setCompareList([]);
    };

    const isInCompare = (carId) => {
        return compareList.some(c => c.id === carId);
    };

    return (
        <CompareContext.Provider value={{
            compareList,
            addToCompare,
            removeFromCompare,
            clearCompare,
            isInCompare
        }}>
            {children}
        </CompareContext.Provider>
    );
};
